import { AccordionItemProps, AccordionList, Typography } from '@sonnen/web-ui';
import { memo, useMemo } from 'react';
import { useAppContext } from '../../AppContext/AppContext';
import { DayAheadLabels } from '../../components/DayAheadLabels/DayAheadLabels';
import { SideCard } from '../../components/SideCard/SideCard';
import { SideCardButton } from '../../components/SideCardButton/SideCardButton';
import { AppRoute } from '../../constants';
import { useCurrentRoute } from '../../hooks/useCurrentRoute';
import { useTranslation } from '../../i18n/i18n';
import { useOfferContext } from '../../OfferContext/OfferContext';
import { OrderFlow } from '../../types';
import { getDayAheadLabels } from '../../utils/utils';

const I18N_SCOPE = 'batteryOptimization.offerCard.';

export const BatteryOptimizationOfferCard = () => {
  const { userProcessing, formValues } = useAppContext();
  const showNextButton = useCurrentRoute() !== AppRoute.TARIFF_OVERVIEW;
  const { offer } = useOfferContext();
  const { t } = useTranslation();
  const { configuration } = offer?.batteryOptimization || {};

  const { terminationPeriodOption } = getDayAheadLabels(configuration?.batteryOptimizationModule);

  const nextButtonDisabled = userProcessing || !formValues.confirmedDynamicTariff || !configuration;

  const listEntries: AccordionItemProps[] = useMemo(() => {
    return [
      {
        label: t(`${I18N_SCOPE}priceLabel`),
        children: <DayAheadLabels configuration={configuration?.batteryOptimizationModule} />,
        alwaysOpen: true,
      },
      {
        label: t(`${I18N_SCOPE}terminationPeriodLabel`),
        children: (
          <Typography.Body1>
            <strong>{t(`modules.priceOptimization.${terminationPeriodOption}`)}</strong>
          </Typography.Body1>
        ),
        alwaysOpen: true,
      },
      {
        label: t('minimumContractDuration'),
        children: (
          <Typography.Body1>
            <strong>{t(`${I18N_SCOPE}minimumContractDuration`)}</strong>
          </Typography.Body1>
        ),
        alwaysOpen: true,
      },
    ];
  }, [t]);

  return (
    <SideCard dataTestId={`${OrderFlow.batteryOptimization}-offer-card`}>
      <Typography.H2>{t(`${I18N_SCOPE}title`)}</Typography.H2>
      {showNextButton && <SideCardButton disabled={nextButtonDisabled} />}
      <AccordionList list={listEntries} dataTestId="battery-optimization" />
    </SideCard>
  );
};

export default memo(BatteryOptimizationOfferCard);
